export default {
      id: "location-usage",
      viewBox: "0 0 12 16",
      url: "/assets/" + "icons.svg#location",
      toString: function () {
        return this.url;
      }
    }